import { render, staticRenderFns } from "./view_Home.vue?vue&type=template&id=bb8bdbc8&scoped=true&"
import script from "./view_Home.vue?vue&type=script&lang=js&"
export * from "./view_Home.vue?vue&type=script&lang=js&"
import style0 from "./view_Home.vue?vue&type=style&index=0&id=bb8bdbc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8bdbc8",
  null
  
)

export default component.exports